const Paypal = require('./paypal/paypal');
const ApplePay = require('./applepay/applepay');
const GooglePay = require('./googlepay/googlepay');
const AmazonPay = require('app_adyen/adyen/express/paymentMethods/amazonpay/amazonPayExpressPart1');

module.exports = {
  Paypal,
  ApplePay,
  GooglePay,
  AmazonPay,
};
